export default __webpack_public_path__ + "static/media/04.ae7d9a39.jpg";